import { formatDate } from 'helpers/date';

export const snakeToPascal = (str) => {
  const s = str.replace(/_(\w)/g, ($, $1) => $1.toUpperCase());
  return `${s.charAt(0).toUpperCase()}${s.substr(1)}`;
};

export const snakeToPascalSpace = (str) => {
  const s = str.replace(/_(\w)/g, ($, $1) => ' ' + $1.toUpperCase());
  return `${s.charAt(0).toUpperCase()}${s.substr(1)}`;
};


export const genericDataColumns = (data = []) => {
  const keys = data.length > 0 ? Object.keys(data[0]) : [];
  const columns = keys.map(key => ({
    title: snakeToPascalSpace(key),
    dataIndex: key,
    render: (value) => {
      if (value === undefined || value === null) return '-';
      if (key.endsWith('_at') || key.startsWith('dt_')) {
        if (typeof value === 'number') {
          value = new Date(value * 1000);
        } else if (typeof value === 'string') {
          value = new Date(Date.parse(value));
        }
        if (value instanceof Date) {
          return formatDate(value, 'yyyy-MM-dd HH:mm');
        }
      }
      if (typeof value === 'number') {
        return Math.round(value * 1000) / 1000;
      }

      return value;
    }
  }));

  return columns;
};
